import { AxiosResponse, HttpStatusCode } from "axios";

export default class ResponseModel {
    Success!: boolean;
    Message?: string[];

    constructor(response: AxiosResponse) {
        if (response == null)
            throw new Error("Response could not be null.");

        if (response.status != HttpStatusCode.Ok)
            throw new Error(`Error on getting response: ${response.status} | ${response.statusText}.`);

        const data = response.data;

        this.Success = data.success;
        this.Message = data.message?.$values || [];

        if (this.Message)
            this.Message = this.Message.map(x => x.trim())
    }
}